import Image from "next/image";
import React from "react";

import Paragraph from '../../Paragraph/Paragraph';
import styles from "./Notion.module.scss";

export default function Notion() {
  return (
    <div className={styles['notion-container']}>
      <Paragraph
        title="Bạn có thể giải thích ngắn gọn về giao dịch quỹ cho độc giả của chúng tôi, những người có thể chưa quen với khái niệm này không?"
        content={[
          'Giao dịch sở hữu, thường được gọi là "giao dịch quỹ," là một hình thức các công ty hoặc nền tảng cấp vốn cho nhà giao dịch để họ giao dịch bằng vốn của công ty thay vì tiền của nhà giao dịch. Trong các chương trình giao dịch cấp vốn, các nhà giao dịch được cung cấp quyền truy cập vào các quỹ này sau khi vượt qua giai đoạn đánh giá nhằm kiểm tra khả năng quản lý rủi ro, đạt được lợi nhuận nhất quán và tuân thủ các quy định của chương trình.',
          'Đổi lại, lợi nhuận thường được chia giữa nhà giao dịch và công ty, trong khi công ty chịu rủi ro lỗ. Các chương trình này thu hút các nhà giao dịch có vốn hạn chế, vì chúng mang lại cơ hội giao dịch với vị thế lớn hơn và kiếm một phần lợi nhuận đáng kể mà không phải chịu rủi ro từ tiền cá nhân.',
        ]}
      />
      <div className={styles['eli-container']}>
        <Image
          src="/images/landing_page_pipfarm/Ellipse1.png"
          alt="Ellipse Icon"
          width={521}
          height={521}
        />
      </div>
    </div>
  );
}
